import { ValidSessionRoute } from '@ferreri/minato-auth-react';

import { PageLayoutMenuFooter } from '@ferreri/prever-component-lib';
import { PetHome } from 'modules/pet/PetHome';
import { TelevetMenu } from 'modules/televet/TelevetMenu';
import { PAGE_TITLE } from 'utils/pageTitle';

export default function HomePage() {
  return (
    <ValidSessionRoute
      loadingComponent={
        <PageLayoutMenuFooter
          sideMenu={<TelevetMenu />}
          title={PAGE_TITLE.home}
        >
          <PetHome />
        </PageLayoutMenuFooter>
      }
    >
      <PageLayoutMenuFooter sideMenu={<TelevetMenu />} title={PAGE_TITLE.home}>
        <PetHome />
      </PageLayoutMenuFooter>
    </ValidSessionRoute>
  );
}
